import { updateNewFlight } from '@/api/passenger'
import { fetchFlightsSameRoute } from '@/api/flight'

const getFlightsSameRoute = (context) => {
  fetchFlightsSameRoute().then((response) => {
    context.commit('FLIGHTSSAMEROUTE_UPDATED', response)
  })
}

const updateFlight = (context, payload) => {
  return updateNewFlight(payload).then((response) => {
    return response
  })
}
export default {
  getFlightsSameRoute,
  updateFlight
}
